'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RequestBaseClass2 = require('./RequestBaseClass');

var _RequestBaseClass3 = _interopRequireDefault(_RequestBaseClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RequestAjaxClass = function (_RequestBaseClass) {
    _inherits(RequestAjaxClass, _RequestBaseClass);

    /**
     * DataType (Standard: json)
     *  @type {string}
     */
    //dataType

    /**
     * Contenttype (Standard : application/json)
     * @type {string}
     */
    //contentType
    /**
     * Typ des Requests (Standard : GET)
     * @type {string}
     */
    //type
    /**
     * Requestdata
     * @type {JSON.object}
     */
    //data
    /**
     * Soll Antwort aus dem Cach geladen werden? (Standart: false)
     * @type {boolean}
     */
    //cache
    /**
     * Sollen die Requestdaten transformiert werden? (Standard : true)
     * Beim Senden von Dokumenten auf 'false' setzen.
     * @type {boolean}
     */
    //processData
    /**
     * Erfolgt der Request als authentifiziertre User? (Standard : false)
     * @type {boolean}
     */
    //auth
    /**
     * ApiUrl
     * @type {string}
     */
    //ApiUrl
    /**
     * ApiKey
     * @type {string}
     */
    //ApiKey
    /**
     * Token
     * @type {string}
     */
    //token
    /**
     * Anonymisierter Token
     * @type {string}
     */
    //anonymoustoken

    function RequestAjaxClass(errorHandlingPage, request) {
        _classCallCheck(this, RequestAjaxClass);

        var _this = _possibleConstructorReturn(this, (RequestAjaxClass.__proto__ || Object.getPrototypeOf(RequestAjaxClass)).call(this, request));

        _this.dataType = 'json';
        _this.contentType = 'application/json';
        _this.type = "GET";
        _this.data = null;
        _this.cache = false;
        _this.processData = true;
        _this.auth = false;
        _this.ApiUrl = null;
        _this.ApiKey = null;
        _this.token = null;
        _this.anonymoustoken = null;
        if (errorHandlingPage !== null && errorHandlingPage !== undefined && typeof errorHandlingPage === 'function') {
            _this.errorHandlingPage = errorHandlingPage;
        }
        return _this;
    }

    _createClass(RequestAjaxClass, [{
        key: 'setDataType',
        value: function setDataType(dataType) {
            this.dataType = dataType;
        }
    }, {
        key: 'setContentType',
        value: function setContentType(contentType) {
            this.contentType = contentType;
        }
    }, {
        key: 'setType',
        value: function setType(type) {
            this.type = type;
        }
    }, {
        key: 'setData',
        value: function setData(data) {
            this.data = data;
        }
    }, {
        key: 'setCache',
        value: function setCache(cache) {
            this.cache = cache;
        }
    }, {
        key: 'setProcessData',
        value: function setProcessData(processData) {
            this.processData = processData;
        }
    }, {
        key: 'setAuth',
        value: function setAuth(auth) {
            this.auth = auth;
        }
    }, {
        key: 'setApiUrl',
        value: function setApiUrl(ApiUrl) {
            this.ApiUrl = ApiUrl;
        }
    }, {
        key: 'setApiKey',
        value: function setApiKey(ApiKey) {
            this.ApiKey = ApiKey;
        }
    }, {
        key: 'setToken',
        value: function setToken(token) {
            this.token = token;
        }
    }, {
        key: 'setAnonymoustoken',
        value: function setAnonymoustoken(token) {
            this.anonymoustoken = token;
        }
    }, {
        key: 'checkValues',
        value: function checkValues() {
            if (this.request !== null && this.request !== undefined && this.dataType !== null && this.dataType !== undefined && this.contentType !== null && this.contentType !== undefined && this.type !== null && this.type !== undefined && (this.cache === true || this.cache === true) && (this.auth === true || this.auth === true) && this.ApiUrl !== null && this.ApiUrl !== undefined && this.ApiKey !== null && this.ApiKey !== undefined && this.auth === true ? this.token !== null ? true : false : true) {
                return true;
            } else {
                return false;
            }
        }
    }, {
        key: 'doRequest',
        value: function doRequest() {
            if (this.checkValues() === true) {
                var me = this;
                var isIE = /*@cc_on!@*/false || !!document.documentMode;
                var isEdge = !isIE && !!window.StyleMedia;
                if (isEdge) {
                    /*$.ajax({
                        dataType: dataType,
                        contentType: contentType,
                        async: async,
                        url: encodeURI(Vas.ApiUrl+ request+"&ts="+Date.now()),
                        type: type,
                        crossDomain: true,
                        //cache: false,
                        processData: processData,
                        beforeSend: function (xhr) {
                            
                            xhr.setRequestHeader('accept-language', "de");
                            xhr.setRequestHeader('x-sts-APIKey', Vas.ApiKey);
                            //xhr.setRequestHeader('Cache-Control','no-cache');
                            xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
                            if (localStorage.getItem("vas_token"))
                                {xhr.setRequestHeader('authorization', localStorage.getItem('vas_token'));}
                            else if (localStorage.getItem("anonymous_token"))
                                {xhr.setRequestHeader('authorization', localStorage.getItem('anonymous_token'));}
                        },
                        data:data,
                        success: function (data) {
                        },
                        error: function (data){
                            if(data){
                                if(data.responseJSON){
                                    if(data.responseJSON.Description){
                                        if(errorHandler && typeof(errorHandler) === 'function') {
                                            errorHandler(data);
                                        }else{
                                            ReactDOM.render(<MessageBox AppURL={Vas.ApplicationUrl} Title={Vas.Resources.Titles["Error"]} Message={data.responseJSON.Description} />
                                                ,document.getElementById('messageContainer'));
                                        }
                                    }
                                }
                            }
                        }
                    })
                    // Use Microsoft XDR
                    //var xdr = new window.XDomainRequest();
                    var xdr = new XMLHttpRequest(); 
                    xdr.addEventListener("progress", updateProgress);
                    xdr.addEventListener("load", transferComplete);
                    xdr.addEventListener("error", transferFailed);
                    xdr.addEventListener("abort", transferCanceled);
                          xdr.open(type, ApiUrl + request + "&ts="+ (new Date()).getTime());
                    //xdr.setRequestHeader('accept-language', localStorage.getItem('vas_language'));
                    xdr.setRequestHeader('x-sts-APIKey', ApiKey);
                    xdr.setRequestHeader('Cache-Control', "no-cache");
                    xdr.setRequestHeader('Content-Type', contentType);
                    xdr.setRequestHeader('Access-Control-Allow-Origin', '*');
                    
                    xdr.onreadystatechange = function (oEvent) {  
                        console.log("stateChange");
                    };
                    if (data){
                        xdr.send(data); 
                    } else {
                        xdr.send(null);
                    }
                    
                    
                    function updateProgress (oEvent) {
                        console.log("update");
                        if (oEvent.lengthComputable) {
                        //var percentComplete = oEvent.loaded / oEvent.total * 100;
                        // ...
                        } else {
                        // Unable to compute progress information since the total size is unknown
                        }
                    }
                    
                    function transferComplete(evt) {
                    console.log("The transfer is complete.");
                    }
                    
                    function transferFailed(evt) {
                        console.log("An error occurred while transferring the file.");
                        console.log(evt);
                    }
                    
                    function transferCanceled(evt) {
                    console.log("The transfer has been canceled by the user.");
                    }*/
                } else {
                    _jquery2.default.ajax({
                        dataType: this.dataType,
                        contentType: this.contentType,
                        async: this.async,
                        url: encodeURI(this.ApiUrl + this.request),
                        type: this.type,
                        cache: this.cache,
                        processData: this.processData,
                        beforeSend: function beforeSend(xhr) {
                            //xhr.setRequestHeader('accept-language', "de");
                            xhr.setRequestHeader('x-sts-APIKey', me.ApiKey);
                            /*if (me.token)
                                {xhr.setRequestHeader('authorization',"bearer "+ me.token);}
                            else if (me.anonymoustoken)
                                {xhr.setRequestHeader('authorization',"bearer "+  me.anonymoustoken);*/
                            if (localStorage.getItem("vas_token")) {
                                xhr.setRequestHeader('authorization', "bearer " + localStorage.getItem("vas_token"));
                            } else if (localStorage.getItem("anonymous_token")) {
                                xhr.setRequestHeader('authorization', "bearer " + localStorage.getItem("anonymous_token"));
                            }
                        },
                        data: this.data,
                        success: function success(data) {
                            if (data) {
                                if (me.auth === false) {
                                    if (me.request !== "/accounts") {
                                        if (data.Token !== me.anonymoustoken) {
                                            localStorage.setItem("anonymous_token", data.Token);
                                            me.anonymoustoken = data.Token;
                                        }
                                    } else {
                                        localStorage.setItem("vas_token", data.Token);
                                        me.token = data.token;
                                    }
                                } else {
                                    if (data.Token !== localStorage.getItem('vas_token')) {
                                        localStorage.setItem("vas_token", data.Token);
                                        me.token = data.Token;
                                    }
                                }
                                if (me.readyCallback && typeof me.readyCallback === 'function') {
                                    me.readyCallback(data);
                                }
                            }
                        },
                        error: function error(data) {
                            if (data) {
                                if (me.errorHandlingPage !== null && me.errorHandlingPage !== undefined) {
                                    me.errorHandlingPage(data);
                                }

                                //if (data.responseJSON){
                                //if (data.responseJSON.Description){
                                if (me.errorHandler && typeof me.errorHandler === 'function') {
                                    me.errorHandler(data);
                                }
                                //}
                                //}
                            }
                        }
                    });
                }
            }
        }
    }]);

    return RequestAjaxClass;
}(_RequestBaseClass3.default);

exports.default = RequestAjaxClass;